import { Localization, GeekItemWithJobTitle, WindowBreakpoint } from '@/models';
import { Role, OpportunityRoleGroup } from '@/models/opportunities';
import { Actions, typedStore } from '@/store';
import { getWindowWidth } from '@/utils';
import { BListGroup } from 'bootstrap-vue';
import Vue from 'vue';

export const rulesMixin = Vue.extend({
  components: {
    'b-list-group': BListGroup,
  },
  data() {
    return {
      isViewportGreaterThanBreakpoint: undefined as unknown as boolean,
    };
  },
  async mounted() {
    this.updateViewportBreakpoint();
    window.addEventListener('resize', this.updateViewportBreakpoint);

    await this.fetchData();

    this.$nextTick(() => {
      const hashLocation = document.location.hash;

      if (hashLocation) {
        (document.querySelector(hashLocation) as Element).scrollIntoView();
      }
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.updateViewportBreakpoint);
  },
  computed: {
    localization(): Localization {
      return typedStore(this).state.geek.current.localization;
    },
    admins(): GeekItemWithJobTitle[] {
      return typedStore(this).state.geek.admins;
    },
    superAdmins(): GeekItemWithJobTitle[] {
      return typedStore(this).state.geek.superAdmins;
    },
    opportunityIssuers(): OpportunityRoleGroup {
      return  {
        geeks: typedStore(this).state.opportunities.issuers,
        opportunityRole: Role.Issuer,
      };
    },
    opportunityAdmins(): OpportunityRoleGroup {
      return {
        geeks: typedStore(this).state.opportunities.admins,
        opportunityRole: Role.Admin,
      };
    },
  },
  methods: {
    updateViewportBreakpoint() {
      this.isViewportGreaterThanBreakpoint = getWindowWidth() >= WindowBreakpoint.Medium;
      this.$store.dispatch(Actions.rules.setLargeScreen, this.isViewportGreaterThanBreakpoint);
    },
    fetchData() {
      throw new Error('Method not implemented');
    },
  },
});
